module.exports = __webpack_public_path__ + "img/wencai.89bef1b2.svg";